import React from "react";
import VisaLogo from "../../../../../../Assets/Finance/VisaLogo.svg";
import MasterCardLogo from "../../../../../../Assets/Finance/MasterCardLogo.svg";
import { ReactComponent as CheckMarkIcon } from "../../../../../../Assets/ActionIcons/CheckMarkIcon.svg";
import { getTextColorBasedOnLuminance } from "../../../../../../Utils/ColorUtils";

export interface PaymentPagePreviewProps {
  brandingCompanyName?: string;
  paymentButtonColor?: string;
}

const PaymentPagePreview: React.FC<PaymentPagePreviewProps> = ({
  brandingCompanyName,
  paymentButtonColor
}) => {
  return (
    <div className="grid grid-cols-2 text-xs my-6 border border-gray-300">
      <div className="bg-white-smoke p-2">
        <span className="font-semibold">{brandingCompanyName}</span>
        <div className="my-4 p-3 bg-white flex flex-col">
          <div className="bg-gray-200 rounded-lg w-16 h-2 mb-6" />
          <div className="bg-gray-200 rounded-lg w-full h-2 mb-2" />
          <div className="bg-gray-200 rounded-lg w-full h-2 mb-2" />
          <div className="bg-gray-200 rounded-lg w-full h-2 mb-2" />
          <div className="bg-gray-200 rounded-lg w-full h-2 mb-2" />
          <div className="bg-gray-200 rounded-lg w-16 h-2 mb-6" />
          <div className="bg-gray-200 rounded-lg w-16 h-2 mb-2" />
          <div className="bg-gray-200 rounded-lg w-20 h-2 mb-4" />
          <div className="bg-gray-200 rounded-lg w-full h-2 mb-2" />
          <div className="bg-gray-200 rounded-lg w-full h-2 mb-2" />
          <div className="bg-gray-200 rounded-lg w-28 h-2 mb-6" />
          <div className="bg-gray-200 rounded-lg w-full h-2 mb-2" />
          <div className="bg-gray-200 rounded-lg w-full h-2 mb-2" />
          <div className="bg-gray-200 rounded-lg w-full h-2 mb-12" />
          <div className="bg-gray-200 rounded-lg w-16 h-2 mb-2 self-end" />
        </div>
      </div>
      <div className="p-2">
        <span className="font-semibold mb-3">Review Payment</span>
        <div className="pt-4 pb-2 border-b border-gray-300">
          <div className="flex justify-between bg-slate-100 rounded p-2">
            <div className="bg-gray-200 w-12 h-2 rounded" />
            <div className="bg-gray-200 w-12 h-2 rounded" />
          </div>
        </div>
        <div className="font-semibold my-3">Selected Payment Method</div>
        <div className="grid grid-cols-3 gap-2">
          <div className="p-0.5 rounded border border-blue-500 flex space-x-1 items-center overflow-hidden">
            <img src={VisaLogo} alt="visa" />
            <div className="h-2 flex-grow bg-gray-200 rounded" />
            <CheckMarkIcon />
          </div>
          <div className="p-0.5 rounded border border-blue-500 flex space-x-1 items-center overflow-hidden">
            <img src={VisaLogo} alt="visa" />
            <div className="h-2 w-6 bg-gray-200 rounded" />
          </div>
          <div className="p-0.5 rounded border border-blue-500 flex space-x-1 items-center overflow-hidden">
            <img src={VisaLogo} alt="visa" />
            <div className="h-2 w-6 bg-gray-200 rounded" />
          </div>
          <div className="p-0.5 rounded border border-blue-500 flex space-x-1 items-center overflow-hidden">
            <img src={MasterCardLogo} alt="visa" />
            <div className="h-2 w-6 bg-gray-200 rounded" />
          </div>
        </div>
        <div className="mt-4 mb-2 font-semibold">Enter Payment Details</div>
        <div className="flex flex-col h-36 w-full bg-white-smoke rounded justify-between p-2">
          <div />
          <button
            className="bg-blue-500 text-white mx-2 py-2 rounded hover:filter hover:brightness-110 transition-all"
            style={
              paymentButtonColor
                ? {
                    background: paymentButtonColor,
                    color: getTextColorBasedOnLuminance(paymentButtonColor)
                  }
                : {}
            }
          >
            Pay
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentPagePreview;
